import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { platformBrowser } from '@angular/platform-browser';
import { extendConfiguration } from './config';
import * as Sentry from '@sentry/browser';
import { attachPlanningCanvasToError } from './app/planning-grid/planning-diagnostics/planning-canvas-capture';
import { keepCaptureVideoInDocument } from './app/planning-grid/planning-diagnostics/sentry-feedback-screenshot';
import { setScheduleSettings } from '@triarc-labs/tl-planning-canvas';
import 'moment/locale/de-ch';

extendConfiguration().then(() => {
  if (environment.production) {
    enableProdMode();
  }

  if (environment.sentry) {
    keepCaptureVideoInDocument();
    const tracePropagationTargets: Array<string | RegExp> = ['localhost', /^\//];
    try {
      tracePropagationTargets.push(new URL(environment.serverApiUrl).origin);
    } catch {
      // settings.json may still replace serverApiUrl after this; interceptor covers API URLs
    }
    Sentry.init({
      dsn: environment.sentry || undefined,
      environment: environment.envName || undefined,
      release: environment.version,
      integrations: [Sentry.browserTracingIntegration()],
      tracesSampleRate: environment.production ? 0.2 : 1.0,
      tracePropagationTargets,
      beforeSend: (event, hint) => attachPlanningCanvasToError(event, hint),
    });
  }
  setScheduleSettings(environment.scheduleSettings);
  import('./app/app.module').then((m) => {
    platformBrowser()
      .bootstrapModule(m.AppModule)
      .catch((err) => console.log(err));
  });
});
